<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="''"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <h5>ランキング</h5>
    <div class="w100 mb-3">
      <div class="container">
        <div class="row">
          <ul class="nav nav-tabs nav-fill">
            <li class="nav-item" v-for="tab in tab_conf" :key="tab">
              <button
                type="button"
                :class="tab_switch(tab.key, 'conf')"
                @click="tab_switch_action(tab.key, 'conf')"
              >
                {{ tab.label }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- {{ race_class_data_obj }} -->
    <div class="w100 mb-5">
      <div class="container">
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">年度</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="sports_year_list"
                v-model="sprm.race_sports_year"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">集計期間</p>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <input
                type="date"
                class="form-control"
                v-model="sprm.cal_start_date"
              />
              <span class="input-group-text">〜</span>
              <input
                type="date"
                class="form-control"
                v-model="sprm.cal_end_date"
              />
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">競技種目</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="license_event_cd_obj_list"
                v-model="sprm.license_event_id"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">大会格式</p>
          </div>
          <div class="col-5 mb-2">
            <bs-select
              :options="race_type_cd_obj_list"
              v-model="sprm.race_type_id"
              :null-option="true"
              :classParam="'form-select'"
            ></bs-select>
          </div>
        </div>
        <div :class="'row mb-1 ' + tabDisplay('series', 'conf', 'flex')">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">シリーズ</p>
          </div>
          <div class="col-6 mb-2">
            <div class="input-group">
              <bs-select
                :options="race_series_cd_obj_list"
                v-model="sprm.race_series_id"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div :class="'row mb-1 ' + tabDisplay('series', 'conf', 'flex')">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">クラス</p>
          </div>
          <div class="col-10 mb-2">
            <div
              class="row"
              v-if="
                this.sprm.license_event_id &&
                this.sprm.race_type_id &&
                this.sprm.race_series_id
              "
            >
              <div
                class="col-3"
                v-for="race_class in race_class_filter_sprm"
                :key="race_class"
              >
                <div class="d-grid">
                  <button
                    type="button"
                    :class="set_race_class_btn_class(race_class.id)"
                    @click="toggle_set_race_class(race_class.id)"
                  >
                    {{ race_class.label }}
                  </button>
                </div>
              </div>
            </div>
            <div
              v-else-if="this.sprm.license_event_id && this.sprm.race_type_id"
              class="row"
            >
              <p class="alert alert-warning">シリーズを選択して下さい</p>
            </div>
            <div v-else class="row">
              <p class="alert alert-warning">
                競技種目・大会格式・シリーズを選択して下さい
              </p>
            </div>
          </div>
        </div>
        <div :class="'row mb-2 ' + tabDisplay('point', 'conf', 'flex')">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">有効線数</p>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <span class="input-group-text">成績上位</span>
              <input type="number" class="form-control" />
              <span class="input-group-text">戦分をカウント</span>
            </div>
          </div>
        </div>
        <div :class="'row mb-1 ' + tabDisplay('point', 'conf', 'flex')">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">ライセンス</p>
          </div>
          <div class="col-10 mb-2">
            <div class="row">
              <div
                class="col-3"
                v-for="license_cd in license_cd_filter_category(1)"
                :key="license_cd"
              >
                <div class="d-grid">
                  <button
                    type="button"
                    :class="set_license_cd_btn_class(license_cd.id)"
                    @click="toggle_set_license_cd(license_cd.id)"
                  >
                    {{ license_cd.label }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button
              :btnClass="'btn-primary'"
              @to_click_event="search_ranking"
              >条件でランキング抽出</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="w100"
      v-if="
        typeof ranking_list === 'object' && Object.keys(ranking_list).length > 0
      "
    >
      <div class="container mb-3">
        <div class="row">
          <ul class="nav nav-tabs nav-fill">
            <li class="nav-item" v-for="tab in tab_list" :key="tab">
              <button
                type="button"
                :class="tab_switch(tab.key, 'list')"
                @click="tab_switch_action(tab.key, 'list')"
              >
                {{ tab.label }}
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div
        :class="'container-fluid mb-3 ' + tabDisplay('result', 'list', 'flex')"
      >
        <table class="table table-bordered table-striped" id="result_table">
          <thead>
            <tr>
              <th
                colspan="4"
                style="border-bottom-color: #fff; border-right-style: none"
              ></th>
              <th colspan="3" style="border-left-style: none"></th>
              <th colspan="3" class="active">第1戦230125</th>
              <th colspan="3" class="active">第2戦230302</th>
              <th colspan="3" class="active">第3戦230285</th>
              <th colspan="2" class="active">第4戦230378</th>
              <th colspan="2" class="active">第5戦230190</th>
              <th colspan="2" class="active">第6戦230399</th>
              <th colspan="3" class="active">第7戦230126</th>
              <th colspan="3" class="active">第8戦230303</th>
              <th style="display: none" colspan="2" rowspan="7"></th>
            </tr>
            <tr>
              <th colspan="4" rowspan="6"></th>
              <th colspan="3" class="active">開催日</th>
              <th colspan="3">04/09</th>
              <th colspan="3">05/14</th>
              <th colspan="3">06/04</th>
              <th colspan="2">06/25</th>
              <th colspan="2">07/30</th>
              <th colspan="2">09/10</th>
              <th colspan="3">10/08</th>
              <th colspan="3">10/29</th>
              <!--th colspan="2"></th-->
            </tr>
            <tr>
              <!--th colspan="3"></th-->
              <th colspan="3" class="active">開催地</th>
              <th colspan="3">ＨＳＲ九州 オフロードコース</th>
              <th colspan="3">オフロードヴィレッジ</th>
              <th colspan="3">スポーツランドSUGO モトクロスコース</th>
              <th colspan="2">世羅グリーンパーク弘楽園</th>
              <th colspan="2">新千歳モーターランド オフロードコース</th>
              <th colspan="2">名阪スポーツランド</th>
              <th colspan="3">ＨＳＲ九州 オフロードコース</th>
              <th colspan="3">オフロードヴィレッジ</th>
              <!--th colspan="2"></th-->
            </tr>
            <tr>
              <!--th colspan="3"></th-->
              <th colspan="3" class="active">天候</th>
              <th colspan="3">晴れ</th>
              <th colspan="3">曇り/雨</th>
              <th colspan="3">晴れ</th>
              <th colspan="2">晴れ</th>
              <th colspan="2">曇り/雨</th>
              <th colspan="2">晴れ/時々雨</th>
              <th colspan="3">雨</th>
              <th colspan="3">晴れ</th>
              <!--th colspan="2"></th-->
            </tr>
            <tr>
              <!--th colspan="3"></th-->
              <th colspan="3" class="active">観客数</th>
              <th colspan="3">2006</th>
              <th colspan="3">3238</th>
              <th colspan="3">2700</th>
              <th colspan="2">2458</th>
              <th colspan="2">598</th>
              <th colspan="2">2050</th>
              <th colspan="3">846</th>
              <th colspan="3">4379</th>
              <!--th colspan="2"></th-->
            </tr>
            <tr>
              <!--th colspan="3"></th-->
              <th colspan="3" class="active">出走数</th>
              <th colspan="3">27</th>
              <th colspan="3">24</th>
              <th colspan="3">23</th>
              <th colspan="2">23</th>
              <th colspan="2">25</th>
              <th colspan="2">22</th>
              <th colspan="3">20</th>
              <th colspan="3">23</th>
              <!--th colspan="2"></th-->
            </tr>
          </thead>
          <thead></thead>
          <thead id="thead_3">
            <tr class="active">
              <th rowspan="3">順位</th>
              <th rowspan="3">ｾﾞｯｹﾝ</th>
              <th rowspan="3">氏名</th>
              <th rowspan="3">クラブ名</th>
              <th rowspan="3">所属県</th>
              <th rowspan="3">ライセンスNo</th>
              <th rowspan="3">合計P</th>
              <th colspan="3">第1戦</th>
              <th colspan="3">第2戦</th>
              <th colspan="3">第3戦</th>
              <th colspan="2">第4戦</th>
              <th colspan="2">第5戦</th>
              <th colspan="2">第6戦</th>
              <th colspan="3">第7戦</th>
              <th colspan="3">第8戦</th>
              <th style="display: none" rowspan="3">合計P</th>
            </tr>
            <tr class="active">
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>1</th>
              <th>2</th>
              <th>1</th>
              <th>2</th>
              <th>1</th>
              <th>2</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1<!-- /51600000 --></td>
              <td>27</td>
              <td>Jay Wilson</td>
              <td></td>
              <td>静岡県</td>
              <td>248475</td>
              <td>516.0</td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">516.0</td>
            </tr>
            <tr>
              <td>2<!-- /27500000 --></td>
              <td>6</td>
              <td>大倉 由揮</td>
              <td></td>
              <td>大阪府</td>
              <td>227055</td>
              <td>275.0</td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--0位--></td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">275.0</td>
            </tr>
            <tr>
              <td>3<!-- /26400000 --></td>
              <td>8</td>
              <td>内田 篤基</td>
              <td></td>
              <td>静岡県</td>
              <td>230001</td>
              <td>264.0</td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--20位--></td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">264.0</td>
            </tr>
            <tr>
              <td>4<!-- /25400000 --></td>
              <td>1</td>
              <td>富田 俊樹</td>
              <td></td>
              <td>愛知県</td>
              <td>602075</td>
              <td>254.0</td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--22位--></td>
              <td></td>
              <td style="display: none">254.0</td>
            </tr>
            <tr>
              <td>5<!-- /22100000 --></td>
              <td>4</td>
              <td>大城 魁之輔</td>
              <td></td>
              <td>愛知県</td>
              <td>234912</td>
              <td>221.0</td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--0位--></td>
              <td><!---90位--></td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--0位--></td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">221.0</td>
            </tr>
            <tr>
              <td>6<!-- /17000000 --></td>
              <td>7</td>
              <td>大塚 豪太</td>
              <td></td>
              <td>栃木県</td>
              <td>234432</td>
              <td>170.0</td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--18位--></td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">170.0</td>
            </tr>
            <tr>
              <td>7<!-- /16100000 --></td>
              <td>13</td>
              <td>安原 志</td>
              <td></td>
              <td>兵庫県</td>
              <td>217910</td>
              <td>161.0</td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--0位--></td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">161.0</td>
            </tr>
            <tr>
              <td>8<!-- /14600000 --></td>
              <td>2</td>
              <td>能塚 智寛</td>
              <td></td>
              <td>兵庫県</td>
              <td>223629</td>
              <td>146.0</td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td><!--0位--></td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td style="display: none">146.0</td>
            </tr>
            <tr>
              <td>9<!-- /14200000 --></td>
              <td>5</td>
              <td>小方 誠</td>
              <td></td>
              <td>埼玉県</td>
              <td>700169</td>
              <td>142.0</td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td></td>
              <td></td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                16.0(3位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                13.0(4位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">142.0</td>
            </tr>
            <tr>
              <td>10<!-- /11000000 --></td>
              <td>10</td>
              <td>小島 庸平</td>
              <td></td>
              <td>三重県</td>
              <td>068681</td>
              <td>110.0</td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--0位--></td>
              <td><!--0位--></td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">110.0</td>
            </tr>
            <tr>
              <td>11<!-- /10400000 --></td>
              <td>12</td>
              <td>道脇 右京</td>
              <td></td>
              <td>愛知県</td>
              <td>208312</td>
              <td>104.0</td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--16位--></td>
              <td><!--17位--></td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--19位--></td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">104.0</td>
            </tr>
            <tr>
              <td>12<!-- /8500000 --></td>
              <td>15</td>
              <td>池本 凌汰</td>
              <td></td>
              <td>札幌</td>
              <td>223162</td>
              <td>85.0</td>
              <td><!--16位--></td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--0位--></td>
              <td><!--16位--></td>
              <td></td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--16位--></td>
              <td style="display: none">85.0</td>
            </tr>
            <tr>
              <td>13<!-- /8200000 --></td>
              <td>19</td>
              <td>池谷 優太</td>
              <td></td>
              <td>兵庫県</td>
              <td>602009</td>
              <td>82.0</td>
              <td><!--19位--></td>
              <td><!--20位--></td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--21位--></td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--0位--></td>
              <td><!---90位--></td>
              <td></td>
              <td></td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">82.0</td>
            </tr>
            <tr>
              <td>14<!-- /6800000 --></td>
              <td>3</td>
              <td>渡辺 祐介</td>
              <td></td>
              <td>宮城県</td>
              <td>209816</td>
              <td>68.0</td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--0位--></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td><!--0位--></td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">68.0</td>
            </tr>
            <tr>
              <td>15<!-- /5300000 --></td>
              <td>16</td>
              <td>町田 旺郷</td>
              <td></td>
              <td>静岡県</td>
              <td>230311</td>
              <td>53.0</td>
              <td><!--18位--></td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                8.0(8位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                10.0(6位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--0位--></td>
              <td><!--0位--></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="display: none">53.0</td>
            </tr>
            <tr>
              <td>16<!-- /4500000 --></td>
              <td>9</td>
              <td>星野 優位</td>
              <td></td>
              <td>埼玉県</td>
              <td>193755</td>
              <td>45.0</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                11.0(5位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                25.0(1位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                9.0(7位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">45.0</td>
            </tr>
            <tr>
              <td>17<!-- /3900000 --></td>
              <td>11</td>
              <td>星野 裕</td>
              <td></td>
              <td>広島県</td>
              <td>601419</td>
              <td>39.0</td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--19位--></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--18位--></td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--23位--></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="display: none">39.0</td>
            </tr>
            <tr>
              <td>18<!-- /3600000 --></td>
              <td>23</td>
              <td>小林 大治朗</td>
              <td></td>
              <td>埼玉県</td>
              <td>070011</td>
              <td>36.0</td>
              <td><!--17位--></td>
              <td><!--19位--></td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--18位--></td>
              <td><!--16位--></td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                5.0(11位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--16位--></td>
              <td><!--17位--></td>
              <td><!--19位--></td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--21位--></td>
              <td><!--16位--></td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">36.0</td>
            </tr>
            <tr>
              <td>19<!-- /3000000 --></td>
              <td>28</td>
              <td>小川 孝平</td>
              <td></td>
              <td>長野県</td>
              <td>220542</td>
              <td>30.0</td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--17位--></td>
              <td><!--18位--></td>
              <td><!--0位--></td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--18位--></td>
              <td><!--16位--></td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--0位--></td>
              <td><!--18位--></td>
              <td></td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">30.0</td>
            </tr>
            <tr>
              <td>20<!-- /2800000 --></td>
              <td>17</td>
              <td>小野 千成</td>
              <td></td>
              <td>東京都</td>
              <td>230230</td>
              <td>28.0</td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--16位--></td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                6.0(10位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td></td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                7.0(9位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--0位--></td>
              <td><!---90位--></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="display: none">28.0</td>
            </tr>
            <tr>
              <td>21<!-- /2700000 --></td>
              <td>20</td>
              <td>西 元気</td>
              <td></td>
              <td>神奈川県</td>
              <td>218618</td>
              <td>27.0</td>
              <td><!--22位--></td>
              <td><!--18位--></td>
              <td><!--17位--></td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--18位--></td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--18位--></td>
              <td><!--0位--></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--16位--></td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td style="display: none">27.0</td>
            </tr>
            <tr>
              <td>22<!-- /2000000 --></td>
              <td>41</td>
              <td>Tray Canard</td>
              <td></td>
              <td></td>
              <td>ZZ0096</td>
              <td>20.0</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                20.0(2位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--0位--></td>
              <td><!--22位--></td>
              <td style="display: none">20.0</td>
            </tr>
            <tr>
              <td>23<!-- /1100000 --></td>
              <td>22</td>
              <td>宗本 駿真</td>
              <td>ＳＰ忠男 広島</td>
              <td>岡山県</td>
              <td>214844</td>
              <td>11.0</td>
              <td><!--21位--></td>
              <td><!--22位--></td>
              <td><!--25位--></td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--20位--></td>
              <td><!--17位--></td>
              <td><!--16位--></td>
              <td><!--17位--></td>
              <td><!--20位--></td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--0位--></td>
              <td><!--17位--></td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--16位--></td>
              <td><!--17位--></td>
              <td></td>
              <td><!--0位--></td>
              <td><!--17位--></td>
              <td><!--17位--></td>
              <td style="display: none">11.0</td>
            </tr>
            <tr>
              <td>24<!-- /500000 --></td>
              <td>34</td>
              <td>竹野 拓実</td>
              <td></td>
              <td>広島県</td>
              <td>229229</td>
              <td>5.0</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td>
                3.0(13位)
                <!-- 										<br>[MIA] -->
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="display: none">5.0</td>
            </tr>
            <tr>
              <td>25<!-- /500000 --></td>
              <td>24</td>
              <td>道脇 白龍</td>
              <td></td>
              <td>愛知県</td>
              <td>223220</td>
              <td>5.0</td>
              <td><!--20位--></td>
              <td><!--21位--></td>
              <td><!--20位--></td>
              <td><!--16位--></td>
              <td><!--17位--></td>
              <td><!--16位--></td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--16位--></td>
              <td><!--17位--></td>
              <td><!--16位--></td>
              <td><!--16位--></td>
              <td>
                2.0(14位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--20位--></td>
              <td><!--16位--></td>
              <td><!--20位--></td>
              <td>
                1.0(15位)
                <!-- 										<br>[MIA] -->
              </td>
              <td><!--19位--></td>
              <td></td>
              <td><!--18位--></td>
              <td><!--18位--></td>
              <td><!--18位--></td>
              <td style="display: none">5.0</td>
            </tr>
            <tr>
              <td>26<!-- /400000 --></td>
              <td>38</td>
              <td>小林 秀真</td>
              <td></td>
              <td>札幌</td>
              <td>229195</td>
              <td>4.0</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td><!--17位--></td>
              <td>
                4.0(12位)
                <!-- 										<br>[MIA] -->
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style="display: none">4.0</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        :class="
          'container mb-2 py-2 ' + tabDisplay('promotion', 'list', 'block')
        "
      >
        <div class="row">
          <div class="col-2">
            <label>昇格条件一覧</label>
          </div>
          <div class="col-6">
            <bs-select
              :options="promotion_cond_obj_list"
              v-model="sprm.cond_id"
              :null-option="true"
              :classParam="'form-select'"
            ></bs-select>
          </div>
          <div class="col-4">
            <button class="btn btn-warning">
              昇格条件から昇降格を設定する
            </button>
          </div>
        </div>
      </div>
      <div
        :class="
          'container-fluid mb-1 ' + tabDisplay('promotion', 'list', 'flex')
        "
      >
        <table
          class="table table-bordered table-striped mb-3"
          id="promotion_table"
        >
          <thead id="thead_3">
            <tr class="active">
              <th>順位</th>
              <th>ｾﾞｯｹﾝ</th>
              <th>氏名</th>
              <th>クラブ名</th>
              <th>所属県</th>
              <th>ライセンスNo</th>
              <th>合計P</th>
              <th>昇降格</th>
              <th>昇格前</th>
              <th>昇格後</th>
              <th>理由</th>
              <th>状態</th>
              <th>登録日</th>
              <th>その他</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1<!-- /51600000 --></td>
              <td>27</td>
              <td>Jay Wilson</td>
              <td></td>
              <td>静岡県</td>
              <td>248475</td>
              <td>516.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>2<!-- /27500000 --></td>
              <td>6</td>
              <td>大倉 由揮</td>
              <td></td>
              <td>大阪府</td>
              <td>227055</td>
              <td>275.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>3<!-- /26400000 --></td>
              <td>8</td>
              <td>内田 篤基</td>
              <td></td>
              <td>静岡県</td>
              <td>230001</td>
              <td>264.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>4<!-- /25400000 --></td>
              <td>1</td>
              <td>富田 俊樹</td>
              <td></td>
              <td>愛知県</td>
              <td>602075</td>
              <td>254.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>5<!-- /22100000 --></td>
              <td>4</td>
              <td>大城 魁之輔</td>
              <td></td>
              <td>愛知県</td>
              <td>234912</td>
              <td>221.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>6<!-- /17000000 --></td>
              <td>7</td>
              <td>大塚 豪太</td>
              <td></td>
              <td>栃木県</td>
              <td>234432</td>
              <td>170.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>7<!-- /16100000 --></td>
              <td>13</td>
              <td>安原 志</td>
              <td></td>
              <td>兵庫県</td>
              <td>217910</td>
              <td>161.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>8<!-- /14600000 --></td>
              <td>2</td>
              <td>能塚 智寛</td>
              <td></td>
              <td>兵庫県</td>
              <td>223629</td>
              <td>146.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>9<!-- /14200000 --></td>
              <td>5</td>
              <td>小方 誠</td>
              <td></td>
              <td>埼玉県</td>
              <td>700169</td>
              <td>142.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>10<!-- /11000000 --></td>
              <td>10</td>
              <td>小島 庸平</td>
              <td></td>
              <td>三重県</td>
              <td>068681</td>
              <td>110.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>11<!-- /10400000 --></td>
              <td>12</td>
              <td>道脇 右京</td>
              <td></td>
              <td>愛知県</td>
              <td>208312</td>
              <td>104.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>12<!-- /8500000 --></td>
              <td>15</td>
              <td>池本 凌汰</td>
              <td></td>
              <td>札幌</td>
              <td>223162</td>
              <td>85.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>13<!-- /8200000 --></td>
              <td>19</td>
              <td>池谷 優太</td>
              <td></td>
              <td>兵庫県</td>
              <td>602009</td>
              <td>82.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>14<!-- /6800000 --></td>
              <td>3</td>
              <td>渡辺 祐介</td>
              <td></td>
              <td>宮城県</td>
              <td>209816</td>
              <td>68.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>15<!-- /5300000 --></td>
              <td>16</td>
              <td>町田 旺郷</td>
              <td></td>
              <td>静岡県</td>
              <td>230311</td>
              <td>53.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>16<!-- /4500000 --></td>
              <td>9</td>
              <td>星野 優位</td>
              <td></td>
              <td>埼玉県</td>
              <td>193755</td>
              <td>45.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>17<!-- /3900000 --></td>
              <td>11</td>
              <td>星野 裕</td>
              <td></td>
              <td>広島県</td>
              <td>601419</td>
              <td>39.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>18<!-- /3600000 --></td>
              <td>23</td>
              <td>小林 大治朗</td>
              <td></td>
              <td>埼玉県</td>
              <td>070011</td>
              <td>36.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>19<!-- /3000000 --></td>
              <td>28</td>
              <td>小川 孝平</td>
              <td></td>
              <td>長野県</td>
              <td>220542</td>
              <td>30.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>20<!-- /2800000 --></td>
              <td>17</td>
              <td>小野 千成</td>
              <td></td>
              <td>東京都</td>
              <td>230230</td>
              <td>28.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>21<!-- /2700000 --></td>
              <td>20</td>
              <td>西 元気</td>
              <td></td>
              <td>神奈川県</td>
              <td>218618</td>
              <td>27.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>22<!-- /2000000 --></td>
              <td>41</td>
              <td>Tray Canard</td>
              <td></td>
              <td></td>
              <td>ZZ0096</td>
              <td>20.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>23<!-- /1100000 --></td>
              <td>22</td>
              <td>宗本 駿真</td>
              <td>ＳＰ忠男 広島</td>
              <td>岡山県</td>
              <td>214844</td>
              <td>11.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>24<!-- /500000 --></td>
              <td>34</td>
              <td>竹野 拓実</td>
              <td></td>
              <td>広島県</td>
              <td>229229</td>
              <td>5.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>25<!-- /500000 --></td>
              <td>24</td>
              <td>道脇 白龍</td>
              <td></td>
              <td>愛知県</td>
              <td>223220</td>
              <td>5.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>26<!-- /400000 --></td>
              <td>38</td>
              <td>小林 秀真</td>
              <td></td>
              <td>札幌</td>
              <td>229195</td>
              <td>4.0</td>
              <td class="text-center">
                <bs-select
                  :options="rank_promotion_type_select_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td class="text-center">MNB</td>
              <td>
                <bs-select
                  :options="license_cd_map_short_label"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td>
                <bs-select
                  :options="rank_promotion_reason_obj_list"
                  v-model="rank_promotion_type_tmp"
                  :null-option="'設定しない'"
                  :classParam="'form-select-sm'"
                ></bs-select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div :class="'container mb-1 ' + tabDisplay('promotion', 'list', 'flex')">
        <div class="row">
          <div class="col">
            <div class="text-start">
              <button class="btn btn-primary" @click="update_promotion">
                更新する
              </button>
            </div>
          </div>
          <div class="col">
            <div class="text-end">
              <button class="btn btn-warning" @click="update_promotion">
                CSV出力する
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
import Common from '../../../common/common'
import BsSelect from '../../atoms/BsSelect.vue'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'RankingView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: 'シリーズランキング',
      fromParentBtn: '',
      ranking_obj: [],
      license_event_cd_obj: [],
      license_cd_obj: [],
      race_type_cd_obj: [],
      race_series_cd_obj: [],
      race_class_data_obj: [],
      rank_promotion_type_obj: [],
      rank_promotion_reason_obj: [],
      rank_promotion_result_obj: [],
      promotion_cond_obj: [],
      sprm: {
        race_sports_year: '',
        cal_start_date: '',
        cal_end_date: '',
        race_type_id: '',
        license_event_id: '',
        series_id: '',
        license_ids_list: [],
        class_ids_list: [],
        cond_id: ''
      },
      tab_active_conf: 'series',
      tab_active_list: 'result',
      tab_conf: [
        {
          key: 'series',
          label: 'シリーズ'
        },
        {
          key: 'point',
          label: 'ポイント'
        }
      ],
      tab_list: [
        {
          key: 'result',
          label: '結果'
        },
        {
          key: 'promotion',
          label: '昇降格'
        }
      ],
      page: 0,
      page_limit: 10,
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert,
    BsSelect
  },
  computed: {
    ...mapState({}),
    sports_year_list: function () {
      const start = 2023
      const nowYear = Common.getNowYear()
      const maxYear = parseInt(nowYear) + 1
      const tmps = []
      for (let i = start; i <= maxYear; i++) {
        tmps.push({
          key: i,
          label: i + '年'
        })
      }
      return tmps
    },
    license_event_cd_obj_list: function () {
      return this.license_event_cd_obj
    },
    license_cd_obj_list: function () {
      // demoのモックで使うのは国内Aと国際B
      const chks = [10, 11]
      return this.license_cd_obj.filter(list =>
        chks.includes(parseInt(list.id))
      )
    },
    race_type_cd_obj_list: function () {
      return this.race_type_cd_obj
    },
    race_series_cd_obj_list: function () {
      return this.race_series_cd_obj
    },
    race_class_data_obj_list: function () {
      return this.race_class_data_obj
    },
    rank_promotion_type_obj_list: function () {
      return this.rank_promotion_type_obj
    },
    rank_promotion_type_select_list: function () {
      // ここで設定するのは自動、申請(昇降格)の３つ
      const chks = [10, 20, 120]
      return this.rank_promotion_type_obj.filter(type =>
        chks.includes(parseInt(type.key))
      )
    },
    rank_promotion_reason_obj_list: function () {
      return this.rank_promotion_reason_obj
    },
    rank_promotion_result_obj_list: function () {
      return this.rank_promotion_result_obj
    },
    promotion_cond_obj_list: function () {
      return [...this.promotion_cond_obj].map(cond => {
        cond.key = cond.id
        return cond
      })
    },
    license_cd_map_short_label: function () {
      return this.license_cd_obj_list.map(list => {
        list.label = list.short_label
        return list
      })
    },
    license_cd_filter_category: function () {
      const license_list = this.license_cd_obj_list.filter(license_cd => {
        if (this.sprm.license_event_id == '') {
          return true
        } else if (
          this.sprm.license_event_id != '' &&
          license_cd.license_event_cd == this.sprm.license_event_id
        ) {
          return true
        }
        return false
      })
      return function (category_id) {
        return license_list.filter(
          license_cd => license_cd.license_category == category_id
        )
      }
    },
    race_class_filter_sprm: function () {
      return this.race_class_data_obj_list
        .filter(race_class => {
          if (this.sprm.license_event_id == '') {
            return true
          } else if (
            this.sprm.license_event_id != '' &&
            race_class.license_event_id == this.sprm.license_event_id
          ) {
            return true
          }
          return false
        })
        .filter(race_class => {
          if (this.sprm.race_series_id == '') {
            return true
          } else if (
            this.sprm.race_series_id != '' &&
            typeof race_class.series === 'object' &&
            race_class.series.find(
              series => series.id == this.sprm.race_series_id
            )
          ) {
            return true
          }
          return false
        })
    },

    attach_target_license_cd: function () {
      const license_ids = (this.sprm || {}).license_ids_list
      return function (target_id) {
        if (
          typeof license_ids === 'object' &&
          license_ids.find(license_id => license_id == target_id)
        ) {
          return license_ids.findIndex(license_id => license_id == target_id)
        }
        return false
      }
    },
    set_license_cd_btn_class: function () {
      const attach = this.attach_target_license_cd
      return function (target_id) {
        const obj = attach(target_id)
        if (obj !== false) {
          return 'btn btn-warning'
        }
        return 'btn btn-light btn-outline-secondary'
      }
    },
    attach_target_race_class: function () {
      const class_ids = (this.sprm || {}).class_ids_list
      return function (target_id) {
        if (
          typeof class_ids === 'object' &&
          class_ids.find(class_id => class_id == target_id)
        ) {
          return class_ids.findIndex(class_id => class_id == target_id)
        }
        return false
      }
    },
    set_race_class_btn_class: function () {
      const attach = this.attach_target_race_class
      return function (target_id) {
        const obj = attach(target_id)
        if (obj !== false) {
          return 'btn btn-warning'
        }
        return 'btn btn-light btn-outline-secondary'
      }
    },
    tabDisplay: function () {
      const self_tab_active_conf = this.tab_active_conf
      const self_tab_active_list = this.tab_active_list
      return function (tab, type, disp_class) {
        const self_tab_active =
          type == 'conf' ? self_tab_active_conf : self_tab_active_list
        let tabClass = 'd-none '
        if (self_tab_active == tab) {
          tabClass = 'd-' + disp_class
        }
        return tabClass
      }
    },
    tab_switch: function () {
      const self_tab_active_conf = this.tab_active_conf
      const self_tab_active_list = this.tab_active_list
      return function (tab, type) {
        const self_tab_active =
          type == 'conf' ? self_tab_active_conf : self_tab_active_list
        let tabClass = 'nav-link '
        // console.log('tab_switch', self_tab_active);
        if (self_tab_active == tab) {
          tabClass += 'active'
        }
        return tabClass
      }
    },
    get_category_data: function () {
      const category_list = this.category_list
      return function (category_id) {
        return category_list.find(category => category.id == category_id)
      }
    },
    get_category_label: function () {
      const get_func = this.get_category_data
      return function (category_id) {
        if (get_func(category_id)) {
          return get_func(category_id).label
        }
        return ''
      }
    },
    ranking_list: function () {
      const lists = [...this.ranking_obj]
      return lists
        .map(list => {
          // list.category_label = this.get_category_label(list.category);
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    category_list: function () {
      // const lists = [...this.category_obj];
      // return lists.sort((a, b) => {
      //   if (parseInt(a.sort) < parseInt(b.sort)) {
      //     return -1;
      //   } else {
      //     return 1;
      //   }
      // });
      return []
    }
  },

  async created() {
    await this.loadLicenseEventCdList()
    await this.loadLicenseCdList()
    await this.loadRaceTypeCdList()
    await this.loadRaceSeriesCdList()
    await this.loadRaceClassDataList()
    await this.loadPromotionCondList()
    await this.loadConfigObj('rank_promotion_type')
    await this.loadConfigObj('rank_promotion_reason')
    await this.loadConfigObj('rank_promotion_result')
    await this.loadSearchParam()
    // await this.loadArticleList();
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = 'シリーズランキングです'
  },

  methods: {
    update_promotion() {
      alert('データを昇降格対象者に登録・更新しました')
    },
    toggle_set_license_cd(license_id) {
      const tmps = this.sprm.license_ids_list
      if (this.attach_target_license_cd(license_id) !== false) {
        const idx = this.attach_target_license_cd(license_id)
        tmps.splice(idx, 1)
      } else {
        tmps.push(license_id)
      }
      this.sprm.license_ids_list = tmps
    },
    toggle_set_race_class(class_id) {
      const tmps = this.sprm.class_ids_list
      if (this.attach_target_race_class(class_id) !== false) {
        const idx = this.attach_target_race_class(class_id)
        tmps.splice(idx, 1)
      } else {
        tmps.push(class_id)
      }
      this.sprm.class_ids_list = tmps
    },
    tab_switch_action(tab, type) {
      if (type == 'conf') {
        this.tab_active_conf = tab
      } else {
        this.tab_active_list = tab
      }
    },
    async delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.article_obj.find(category => {
          return category.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'article' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(async () => {
            await this.loadArticleList()
          })
      }
    },
    async loadArticleList() {
      const params = {}
      params['stat'] = [1]
      if (this.sprm.category_id) params['category_id'] = this.sprm.category_id
      params['pagelimit'] = false
      if (this.page >= 0) params['p'] = this.page
      params['pageorder'] = 'mfj_article_data.sort'
      // params['pageorder'] = this.page_order;
      params['pagesort'] = 'ASC'
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'member'
      })
      await this.basicPosts_S(config.BASE_API_URL + '/article/lists', params)
        .then(async response => {
          console.log('loadArticleList response', response)
          this.article_obj =
            response.data && response.data.body ? response.data.body : []
          this.$store.dispatch('setSearchParam', {
            data: params,
            target: 'article'
          })
          const setPageData = {}
          setPageData.data =
            response.data && response.data.pager ? response.data.pager : {}
          setPageData.target = 'article'
          this.$store.dispatch('setPager', setPageData)
        })
        .catch(async err => {
          console.log(err)
          this.article_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdList response', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_event_cd_obj', err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceTypeCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_type_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceTypeCdList response', response)
          this.race_type_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.race_type_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceSeriesCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_series_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceSeriesCdList response', response)
          this.race_series_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.race_series_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceClassDataList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_class_data/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceClassDataList response', response)
          this.race_class_data_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.race_class_data_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadPromotionCondList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/rank_promotion_cond/lists',
        params
      )
        .then(async response => {
          console.log('loadPromotionCondList response', response)
          this.promotion_cond_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.promotion_cond_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadConfigObj(param) {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/config/' + param, params)
        .then(async response => {
          console.log('loadConfigObj response', response)
          this[param + '_obj'] =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this[param + '_obj'] = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async search_ranking() {
      this.isLoading = true;
      try {
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.page = 0
        // const category_id =
        //   this.sprm.category_id != '' ? this.sprm.category_id : false;
        // await this.loadArticleList(category_id);
        this.ranking_obj.push({})
      } finally {
        this.isLoading = false;
      }
    },
    clear() {
      const params = { ...this.sprm }
      if (typeof params === 'object') {
        Object.keys(params).forEach(sprm_key => {
          params[sprm_key] = ''
        })
      }
      this.sprm = params
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'article'
      })
    },
    async pageAction(page) {
      this.page = page
      await this.loadArticleList()
    },
    handleClick(target) {
      this.$router.push({ path: '/article/' + target + '/' })
    },
    async copyClick(target) {
      const post_url = config.BASE_API_URL + '/article/copy/' + target

      let result = false
      await this.basicPosts_I(post_url, {})
        .then(async response => {
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.targetid = response.data.body[0].id
            this.alertMessage = '複製しました'
            this.alertClass = 'alert-success'
            result = true
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            // this.targetid = add;
            this.alertMessage = '複製できませんでした 500'
            this.alertClass = 'alert-danger'
          } else {
            console.log('error update status 200 error')
            // this.targetid = 'add';
            this.alertMessage = '複製できませんでした。el'
            this.alertClass = 'alert-danger'
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = '複製できませんでした。CE'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) {
            await this.loadArticleList()
          }
          this.$forceUpdate()
        })

      // this.$router.push({ path: '/article/' + target + '/' })
    },
    async loadSearchParam() {
      const params = { ...this.$store.getters.getSearchParam('article') }
      if (params) {
        Object.keys(params).forEach(key => {
          if (this.is_json(params[key])) {
            params[key] = JSON.parse(params[key])
          }
          this.sprm[key] = params[key]
        })
      }
    }
  }
}
</script>
